import { inject, Provider } from '@angular/core';
import {
  ACCOUNT_SETTINGS_TABS,
  AccountSettingsTab,
  FEATURE_FLAGS,
  FeatureFlagsService,
} from '@kuiper/ibusiness-core';
import { BackgroundTaskListComponent } from './background-task-list.component';

/** Dib's Background Tasks list as an Account Settings tab, behind the invoice_excel_import flag. */
export function provideBackgroundTasksAccountTab(): Provider {
  return {
    provide: ACCOUNT_SETTINGS_TABS,
    useFactory: (): AccountSettingsTab[] =>
      inject(FeatureFlagsService).getFeatureFlagValue(
        FEATURE_FLAGS.DIB.invoice_excel_import
      )
        ? [
            {
              routingParam: 'background-tasks',
              titleKey: 'account_settings_screen_background_tasks_tab_label',
              component: BackgroundTaskListComponent,
            },
          ]
        : [],
  };
}
